<template>
  <div>
    <a :class="colour" :href="link">{{ text }}</a>
  </div>
</template>

<script>
export default {
   data: function () {
    return {}
  },
  props: {
    text: String,
    link: String,
    colour: String
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

div {
  padding: 0 1.25rem;
  text-align: center;
  margin-bottom: 1.25rem;
}

a {
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  border-radius: 0.3125rem;
  padding: 0.75rem;
  color: $col_orange;
  font-size: .875rem;
  font-weight: 700;
  display: inline-block;
  margin: 0.325rem auto;
  text-decoration: none;
  max-width: 30rem;
  width: 100%;
  border: .0625rem solid;
  box-sizing: border-box;

  &.org {
    border-color: $col_orange;
    background: $col_orange;
    color: $col_white;

    &:hover,
    &:focus {
      background: lighten($col_orange, 10%);
    }
  }

  &.orgWire {
    border-color: $col_orange;
    background: transparent;
    color: $col_orange;

    &:hover,
    &:focus {
      background: $col_orange;
      color: $col_white;
    }
  }

  &.purple {
    background: $col_purple;
    color: $col_white;
    border-color: $col_purple;

    &:hover,
    &:focus {
      background: lighten($col_purple, 10%);
    }
  }
}

</style>